import Vue from 'vue'
import Vuex from 'vuex'
import { DEFAULT_LANG } from '@/lang/config'
import { removeToken, getToken } from '@/utils/auth'
import { logout as logoutApi } from '@/api/base'

Vue.use(Vuex)

const LANG_KEY = 'language'
const USER_KEY = 'user_info'
const CATE_ID_KEY = 'active_cate_id'

export default new Vuex.Store({
  state: {
    language: localStorage.getItem(LANG_KEY) || DEFAULT_LANG,
    userInfo: JSON.parse(localStorage.getItem(USER_KEY) || 'null'),
    token: getToken() || '',
    activeCateId: localStorage.getItem(CATE_ID_KEY) || ''
  },
  getters: {
    language: state => state.language,
    userInfo: state => state.userInfo,
    isLoggedIn: state => !!state.token,
    activeCateId: state => state.activeCateId
  },
  mutations: {
    SET_LANGUAGE(state, lang) {
      state.language = lang
      localStorage.setItem(LANG_KEY, lang)
    },
    SET_ACTIVE_CATE_ID(state, id) {
      state.activeCateId = id
      localStorage.setItem(CATE_ID_KEY, id)
    },
    SET_USER(state, user) {
      state.userInfo = user
      if (user) {
        localStorage.setItem(USER_KEY, JSON.stringify(user))
      } else {
        localStorage.removeItem(USER_KEY)
      }
    },
    SET_TOKEN(state, token) {
      state.token = token || ''
    }
  },
  actions: {
    setLanguage({ commit }, lang) {
      commit('SET_LANGUAGE', lang)
    },
    setActiveCateId({ commit }, id) {
      commit('SET_ACTIVE_CATE_ID', id)
    },
    login({ commit }, { user, token }) {
      commit('SET_USER', user)
      commit('SET_TOKEN', token)
    },
    updateUser({ commit }, user) {
      commit('SET_USER', user)
    },
    logout({ commit }) {
      removeToken()
      commit('SET_USER', null)
      commit('SET_TOKEN', '')
    }
  },
  modules: {}
})
